<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="6" lg="4">
        <div class="brand-card">
          <div class="brand-card-header bg-dark">
            <h4 class="mb-0">{{user.full_name}}</h4>
          </div>
          <div class="card-body">
            <p><span class="text-muted">{{ 'email' | translate('global') }}: </span>
              <span>{{user.email}}</span>
            </p>
            <p><span class="text-muted">{{ 'roles' | translate('global') }}: </span>
              <span v-for="(role, key) in roles" :key="key">
                <b-badge class="ml-1"> {{ role.name }} </b-badge>
              </span>
            </p>
          </div>
        </div>
      </b-col>
      <b-col cols="6">
        <div class="brand-card">
          <div class="brand-card-header bg-dark">
            <h4 class="mb-0">{{ 'structures' | translate('global') }}</h4>
          </div>
          <div v-if="spinners.contentIsLoading" class="text-center mt-4 mb-4">
            <b-spinner type="grow" variant="primary"/>
          </div>
          <div v-else class="card-body">
            <EmptyTable v-if="!tableItems.length" :values="emptyTable" class="mb-0"/>
            <b-table v-else class="table-sm"
                     borderless head-variant="light" :fields="tableFields" :items="tableItems">
            </b-table>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import { mapGetters, mapActions } from 'vuex';
import VuexTypes from '@/store/types/index';
import EmptyTable from '@/views/sharedComponents/EmptyTableData';
import forEach from 'lodash.foreach';

const DashboardTypes = VuexTypes.dashboard;
export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      emptyTable: {
        text: this.$t('dashboard_structure_table_empty', 'global')
      },
      tableFields: [
        { key: 'structure', label: this.$t('structure', 'global') },
        { key: 'role', label: this.$t('role', 'global') },
        { key: 'balance', label: this.$t('balance', 'global') }
      ],
      tableItems: [],
    };
  },
  components: {
    EmptyTable
  },
  computed: {
    ...mapGetters('Auth', [
      'user',
      'roles',
    ]),
    ...mapGetters('Dashboard', [
      'dashboardStructuresData',
    ]),
  },
  watch: {
    dashboardStructuresData: {
      handler: function () {
        if (this.dashboardStructuresData['status'] === statuses.LOADED) {
          this.fillStructureTableData();
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Dashboard', [
      DashboardTypes.DASHBOARD_STRUCTURES_DATA,
    ]),
    getData() {
      this.DASHBOARD_STRUCTURES_DATA();
    },
    fillStructureTableData() {
      const roles = this.dashboardStructuresData.data.roles;
      const structures = this.dashboardStructuresData.data['user_structures'];
      const result = [];

      forEach(structures, (structure) => {
        const roleName = roles[structure['pivot']['role_id']].name;
        result.push({
          structure: structure['name'],
          role: roleName,
          balance: (Number(structure['balance']['available']) - Number(structure['balance']['spent'])).toFixed(2)
        });
      });

      this.tableItems = result;
    }
  }
};
</script>
